import {NgModule} from '@angular/core';
import {LowercaseDirective} from './lowercase.validator';
import {NumericDirective} from './numeric.validator';
import {PasswordDirective} from './password.validator';
import {RepeatCharDirective} from './repeat-char.validator';
import {SequenceDirective} from './sequence.validator';
import {SpaceCharDirective} from './space-char.validator';
import {SpecialCharDirective} from './special-char.validator';
import {UppercaseDirective} from './uppercase.validator';

export * from './common';

export * from './lowercase.validator';
export * from './numeric.validator';
export * from './password.validator';
export * from './repeat-char.validator';
export * from './sequence.validator';
export * from './space-char.validator';
export * from './special-char.validator';
export * from './uppercase.validator';

@NgModule({
  declarations: [
    LowercaseDirective,
    NumericDirective,
    PasswordDirective,
    RepeatCharDirective,
    SequenceDirective,
    SpaceCharDirective,
    SpecialCharDirective,
    UppercaseDirective,
  ],
  exports: [
    LowercaseDirective,
    NumericDirective,
    PasswordDirective,
    RepeatCharDirective,
    SequenceDirective,
    SpaceCharDirective,
    SpecialCharDirective,
    UppercaseDirective,
  ],
})
export class PasswordValidatorModule {}



// WEBPACK FOOTER //
// ./src/app/shared/validators/index.ts